"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function valueToString(value) {
    var result = '';
    switch (typeof value) {
        case 'number': {
            result = value.toString();
            break;
        }
        case 'string': {
            result = value;
            break;
        }
        case 'boolean': {
            result = value ? 'True' : 'False';
            break;
        }
        default: {
            if (value === null || value === undefined) {
                result = 'None';
                break;
            }
            if (Array.isArray(value)) {
                result = value.map(function (item) { return valueToString(item); }).join(', ');
                break;
            }
            result = "(".concat(Object.keys(value)
                .map(function (key) { return "".concat(key, ": ").concat(valueToString(value[key])); })
                .join(', '), ")");
            break;
        }
    }
    // limit the number of chars we print to screen (gets truncated anyway)
    return result.substring(0, 100) || '[Empty]';
}
exports.default = valueToString;
